import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { EquipamentoForm } from "../typings";
import http from "infra/http";

export function useEquipamentoDetalhe(id?: string) {
  return useQuery<EquipamentoForm, AxiosError>(
    `/v1/equipamento/${id}`,
    async () => {
      const { data } = await http.get<EquipamentoForm>(
        `/v1/equipamento/${id}`
      );

      return data;
    }, {
      enabled: !!id
    }
  );
}
